import { useSelfMemberState } from '@/hooks/useSelfMemberState'
import { useCapabilitiesStore } from '@/stores/capabilities'

/**
 * returns whether the corresponding button should be visible and enabled
 * based on the capabilities and the current state
 * - button `visible` if one of the `capabilities` is enabled
 * - button `enabled` if the current state matches the `capability` state
 * i.e. (currently muted and can unmute) or (currently unmute and can mute)
 */
export const useSelfVideoButtonState = () => {
  const selfVideoMuted = useSelfMemberState({
    subscriptionKey: 'videoMuted',
  })
  const selfVideoCapabilityOff = useCapabilitiesStore(
    state => state.selfVideoCapabilityOff,
  )
  const selfVideoCapabilityOn = useCapabilitiesStore(
    state => state.selfVideoCapabilityOn,
  )

  // button visible if one of the capabilities is enabled
  const isVideoButtonVisible = selfVideoCapabilityOn || selfVideoCapabilityOff

  // muted and can unmute
  const canUnmute = selfVideoMuted && selfVideoCapabilityOn
  // unmuted and can mute
  const canMute = !selfVideoMuted && selfVideoCapabilityOff

  // check if button can perform the necessary next action
  const isVideoButtonEnabled = canUnmute || canMute

  return { isVideoButtonEnabled, isVideoButtonVisible }
}
